export default "__VITE_ASSET__CkVX37t2__"